import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import Compare from "@/pages/home/components/Compare";
import CutScenes from "@/pages/home/components/CutScenes";
import Plot from "@/pages/home/components/Plot";
import Characters from "@/pages/home/components/Characters";
import Intimate from "@/pages/home/components/Intimate";
import Ending from "@/pages/home/components/Ending";
import Behind from "@/pages/home/components/Behind";
import Faq from "@/pages/home/components/Faq";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <Overview />
        <Compare />
        <CutScenes />
        <Plot />
        <Characters />
        <Intimate />
        <Ending />
        <Behind />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}